module.exports = __webpack_public_path__ + "95d0f2ea454313bded573bdd9056be78.svg";